<!-- Modal RIDE -->
<ng-template #rideModal let-modal="modal">
  <div class="modal-header">
    <h5 class="modal-title">RIDE - Nota de Crédito</h5>
    <button type="button" class="close" aria-label="Cerrar" (click)="rideModalRef?.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-0">
    <iframe [src]="rideUrl" style="width: 100%; height: 600px; border: none;"></iframe>
  </div>
</ng-template>

<!-- breadcrumb -->
<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Notas de Crédito</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Transacciones</span>
    </div>
  </div>
</div>

<!-- Filtros -->
<div class="row row-sm mb-3">
  <div class="col-12">
    <div class="card control-panel-card">
      <div class="card-body">
        <div class="row g-4 align-items-end">
          <div class="col-12 col-xl-8">
            <h6 class="control-section-title">Filtrar</h6>
            <div class="row g-3 align-items-end">
              <div class="col-12 col-md-5">
                <label class="form-label">Desde</label>
                <input type="date" class="form-control" [(ngModel)]="fechaInicio">
              </div>
              <div class="col-12 col-md-5">
                <label class="form-label">Hasta</label>
                <input type="date" class="form-control" [(ngModel)]="fechaFin">
              </div>
              <div class="col-12 col-md-2">
                <button class="btn btn-secondary w-100" (click)="aplicarFiltros()">
                  <i class="fe fe-filter me-1"></i> Aplicar
                </button>
              </div>
            </div>
          </div>

          <div class="col-12 col-xl-4 control-actions-section">
            <h6 class="control-section-title">Acciones</h6>
            <button class="btn btn-success w-100" (click)="exportarExcel()" [disabled]="spinnerBoolean">
              <i class="fe fe-download me-1"></i> Exportar Excel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Tabla -->
<div class="row row-sm">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                 class="table table-bordered table-striped table-hover dt-ext mobile-friendly-table documentos-table">
            <thead>
              <tr>
                <th style="min-width: 40px;">#</th>
                <th style="min-width: 130px;">Secuencial Nota</th>
                <th style="min-width: 140px;">Factura Modificada</th>
                <th style="min-width: 140px;">Beneficiario</th>
                <th style="min-width: 90px;">Total</th>
                <th style="min-width: 100px;">Cédula</th>
                <th style="min-width: 90px;">Forma Pago</th>
                <th style="min-width: 90px;">Fecha</th>
                <th style="min-width: 60px; font-size: 0.75rem; padding: 0.25rem !important;">Firmado</th>
                <th style="min-width: 60px; font-size: 0.75rem; padding: 0.25rem !important;">Enviado</th>
                <th style="min-width: 70px; font-size: 0.75rem; padding: 0.25rem !important;">Autorizado</th>
                <th style="min-width: 80px; font-size: 0.75rem; padding: 0.25rem !important;">Enviado Cliente</th>
                <th style="min-width: 120px;">Sucursal</th>
                <th style="min-width: 120px;">Facturador</th>
                <th style="min-width: 100px;">Estado</th>
                <th style="min-width: 160px;">Razón</th>
                <th style="min-width: 80px;">Acciones</th>
              </tr>
            </thead>
            <tbody>
              @for (n of notas; track n.COD_TRAC; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td><span class="badge bg-primary">{{ n.NUM_TRACNOT }}</span></td>
                  <td>{{ n.NUMFACNOT_TRAC }}</td>
                  <td>{{ n.nombre_cliente?.trim() ? n.nombre_cliente : n.NOM_CLI }}</td>
                  <td><strong>$ {{ n.TOTPAG_TRAC }}</strong></td>
                  <td>{{ n.cedula_cliente?.trim() ? n.cedula_cliente : n.CED_CLI }}</td>
                  <td>{{ n.METPAG_TRAC }}</td>
                  <td>{{ formatFecha(n.FEC_TRAC) }}</td>
                  <td class="text-center" style="padding: 0.25rem !important; vertical-align: middle;">
                    @if (shouldShowCheck('firmado', n)) {
                      <i class="fe fe-check" style="color: #28a745; font-size: 14px;"></i>
                    }
                  </td>
                  <td class="text-center" style="padding: 0.25rem !important; vertical-align: middle;">
                    @if (shouldShowCheck('enviado', n)) {
                      <i class="fe fe-check" style="color: #28a745; font-size: 14px;"></i>
                    }
                  </td>
                  <td class="text-center" style="padding: 0.25rem !important; vertical-align: middle;">
                    @if (shouldShowCheck('autorizado', n)) {
                      <i class="fe fe-check" style="color: #28a745; font-size: 14px;"></i>
                    }
                  </td>
                  <td class="text-center" style="padding: 0.25rem !important; vertical-align: middle;">
                    @if (shouldShowCheck('enviadoCliente', n)) {
                      <i class="fe fe-check" style="color: #28a745; font-size: 14px;"></i>
                    }
                  </td>
                  <td>{{ n.sucursal }}</td>
                  <td>{{ n.nombre_usuario }}</td>
                  <td>
                    <span [ngClass]="'badge ' + getEstadoBadgeClass(n.estadoFactura)">
                      {{ getEstadoLabel(n.estadoFactura) }}
                    </span>
                  </td>
                  <td>{{ n.OBS_TRAC }}</td>
                  <td class="text-center" style="min-width: 80px;">
                    <div ngbDropdown container="body">
                      <button class="btn btn-sm btn-primary" ngbDropdownToggle type="button" title="Opciones">
                        <i class="fe fe-settings"></i>
                      </button>
                      <div ngbDropdownMenu>
                        <a ngbDropdownItem href="javascript:;" (click)="generarRide(n)">
                          <i class="zmdi zmdi-collection-pdf text-danger"></i> Ver RIDE
                        </a>
                        @if (puedeEnviarSRI(n)) {
                          <a ngbDropdownItem href="javascript:;" (click)="enviarNotaSRI(n)" [class.disabled]="estaEnviandoSRI(n)">
                            @if (estaEnviandoSRI(n)) {
                              <span class="spinner-border spinner-border-sm text-success me-1"></span> Enviando...
                            } @else {
                              <i class="fe fe-send text-success"></i> Enviar al SRI
                            }
                          </a>
                        }
                      </div>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
